import React, { forwardRef } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import CheckmarxMappingForm from './CheckmarxMappingForm';

function CheckmarxCredentialsForm(props, ref){

    const fields = [{
        name: "apiEndpoint",
        label: "Checkmarx Endpoint",
        required: true,
        rules:[urlRegexValidator],
    },{
        name: "username",
        label: "Username",
        required: true
    }, {
        name: "password",
        label: "Password",
        type: FieldTypes.PASSWORD,
        required: true
    }]
    
    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={CheckmarxMappingForm}
        />
    )
}

export default forwardRef(CheckmarxCredentialsForm);